import React from "react";
import { PropTypes } from "prop-types";

function StoreIcon({ className, color }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color || "inherit"}
        d="M853.333333 170.666667H170.666667v85.333333h682.666666V170.666667z m42.666667 426.666666v-85.333333l-42.666667-213.333333H170.666667L128 512v85.333333h42.666667v256h426.666666V597.333333h170.666667v256h85.333333V597.333333h42.666667z m-384 170.666667H256v-170.666667h256v170.666667z"
      />
    </svg>
  );
}

StoreIcon.defaultProps = {
  color: "#888888",
};

StoreIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default StoreIcon;
